import { cn } from "@/lib/utils";

interface JsonLogoProps {
  className?: string;
  size?: number;
}

export const JsonLogo = ({ className, size = 20 }: JsonLogoProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("text-primary", className)}
    >
      {/* Left brace { */}
      <path
        d="M6 4C4.5 4 3.5 5 3.5 6.5V10C3.5 11 2.5 12 1.5 12C2.5 12 3.5 13 3.5 14V17.5C3.5 19 4.5 20 6 20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Right brace } */}
      <path
        d="M18 4C19.5 4 20.5 5 20.5 6.5V10C20.5 11 21.5 12 22.5 12C21.5 12 20.5 13 20.5 14V17.5C20.5 19 19.5 20 18 20"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      
      {/* Center slash / */}
      <path
        d="M14 7L10 17"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};